import React from 'react'
import cn from 'classnames'
import styles from './Tabs.module.scss'

interface Props {
  options: TOption[]
  defaultTab?: string
  onChange?: (tab: string) => void
  children?: React.ReactNode
}

export const Tabs = ({ options, defaultTab, onChange, children }: Props) => {
  const [tab, setTab] = React.useState(defaultTab || options[0]?.value || '')

  const handleChange = React.useCallback((tab: string) => {
    setTab(tab)
    onChange && onChange(tab)
  }, [onChange])

  return (
    <div className={styles.root}>
      <div className={styles.tabs}>
        {options.map(option => (
          <div
            key={option.value}
            className={cn(styles.tab, option.value === tab && styles.active)}
            onClick={() => handleChange(option.value)}
          >
            {option.label}
          </div>
        ))}
      </div>

      {children && (
        <div className={styles.content}>
          {children}
        </div>
      )}
    </div>
  )
}
